import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-delete-new-scheduling-suggestions',
  templateUrl: './confirm-delete-new-scheduling-suggestions.component.html',
  styleUrls: ['./confirm-delete-new-scheduling-suggestions.component.scss']
})
export class ConfirmDeleteNewSchedulingSuggestionsComponent implements OnInit {

  public form: FormGroup;
  public scheduleSuggestionsFormArray: FormArray;
  @Output() isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ConfirmDeleteNewSchedulingSuggestionsComponent>
  ) {
    this.form = this.data;
  }

  public ngOnInit(): void {
    this.scheduleSuggestionsFormArray = this.form.get('scheduleSuggestions') as FormArray;
  }

  public closeDialog(): void {
    this.matDialogRef.close(true);
  }

  public deleteAllSchedulingSuggestions(): void {
    this.isLoading.emit(true);
    this.scheduleSuggestionsFormArray.clear();
    if (this.form.get('companyScheduleSuggestion') && this.form.get('companyScheduleSuggestion').value) {
      this.form.get('scheduleSuggestionsStatus').setValue('standardSuggested');
    }
    if (this.form.get('scheduleSuggestionsStatus') && this.form.get('scheduleSuggestionsStatus').value === 'newScheduleSuggestion') {
      this.form.get('scheduleSuggestionsStatus').setValue(null);
    }
    if (this.form.get('scheduleSuggestionsWasChanged') ) {
      this.form.get('scheduleSuggestionsWasChanged').setValue(true);
    }
    this.closeDialog();
    this.isLoading.emit(false);
  }
}
